<template>
  <section>
    <div class="section_title">
      <h1 class="">スマートフォンアプリ&emsp;サービス終了のお知らせ</h1>
    </div>
    <p class="mt-5">
      平素はマナビス化粧品をご利用いただき、誠にありがとうございます。<br><br>
      この度、誠に勝手ながら、スマートフォンアプリ（Android・iOS）のサービスを2025年3月31日をもちまして終了させていただくこととなりました。<br><br>
      これまで多くの皆さまにご利用いただきましたこと、心より御礼申し上げます。<br><br>
      スマートフォンアプリをご利用いただいている皆さまは、今後はスマートフォンブラウザからご利用いただけるWeb版をご利用いただきますようお願い申し上げます。
    </p>
    <h3 class="mt-5">■MSC会員サイト（Web版）</h3>
      <a href="https://www.manavis-cosme.co.jp/web/" class="mt-3">https://www.manavis-cosme.co.jp/web/</a>
    <h3 class="mt-5 pt-5">【スマートフォンアプリ サービス終了日】</h3>
      <p class="mt-3">
        2025年3月31日（月）
        </p>
      <p class="mt-3">
        ※現在スマートフォンアプリをインストールされている場合、サービス終了後はご利用いただけなくなります。今後はWeb版をご利用いただきますようお願い申し上げます。
      </p>
  </section>
</template>

<script>
export default{

}
</script>